import { BASE_URLS, GET } from "@/src/shared/api";
import { PageType } from "@/src/shared/models";
import { GetProductType } from "@/src/shared/schemas/products";
import queryString from "query-string";

export const getProductsList = async (
    filters?: Record<string, any>,
    options?: RequestInit,
): Promise<PageType<GetProductType>> => {
    const activeResponse = await GET(
        `${BASE_URLS.PRODUCT}?${queryString.stringify({ status: "ACTIVE", ...filters })}`,
        { ...options }
    );
    const inactiveResponse = await GET(
        `${BASE_URLS.PRODUCT}?${queryString.stringify({ status: "INACTIVE", ...filters })}`,
        { ...options }
    );

    const activeData = await activeResponse.json();
    const inactiveData = await inactiveResponse.json();


    const combinedData = {
        ...activeData,
        content: [...(activeData.content || []), ...(inactiveData.content || [])],
    };

    return combinedData;
};

export const getProductById = async (
    options: { id: string },
): Promise<GetProductType> => {
    const response = await GET(`${BASE_URLS.PRODUCT}/${options.id}`);
    return response.json();
};
